













































import { Component, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import pdf from "vue-pdf";
import { InsertExecuteEducation } from "@/api/pdOutPatient/pdEducation/pdExecuteEducation";
import { GetKnowledgeFileType } from "@/api/pdOutPatient/pdEducation/pdKnowledge";
@Component({
  components: {
    pdf
  }
})
export default class PdExecuteEducationPlay extends AbpBase {
  @Prop() pdExecuteEducation: any;
  executeEducation: any = {};
  rules = {};
  fileType: any = "";
  currentPage = 0;
  pageCount = 0;
  baseUrl : string = `http://${location.hostname}:${SERVER_PORT}`;

  @Watch("pdExecuteEducation", { immediate: false, deep: true })
  async onKnowledeChanged() {
    if (this.pdExecuteEducation) {
      var newObj = Object.assign({}, this.pdExecuteEducation);
      this.executeEducation = newObj;
      this.executeEducation.startTime = new Date();
      var res = await GetKnowledgeFileType(this.executeEducation.fileName);
      this.fileType = res.objects;
    }
  }

  async submit() {
    this.executeEducation.endTime = new Date();
    await InsertExecuteEducation(this.executeEducation);
    return true;
  }
  handlePageChange(val: any) {
    this.currentPage = val;
  }
  loadPdfHandler(e) {
    this.currentPage = 1; // 加载的时候先加载第一页
  }

  handleExport() {
    var elemIF = document.createElement("iframe");
    elemIF.src = this.baseUrl+this.executeEducation.url;
    elemIF.name = this.executeEducation.fileName;
    elemIF.style.display = "none";
    document.body.appendChild(elemIF);
  }
  constructor() {
    super();
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/pdOutPatient/pdEducation/pdExecuteEducation/pdExecuteEducationPlay.vue